import React from "react";
import "./GroundClasses.css";
import { Link } from "react-router-dom";

const GroundClasses = () => {
  return (
    <section className="ground-section">
      <div className="container">

        {/* HEADER */}
        <div className="gc-head text-center">
          <h2>Ground Classes for DGCA Examination</h2>
          <p>
            Comprehensive training programs designed to transform aspiring pilots into certified professionals.
          </p>
        </div>

        {/* ===== ROW 1 ===== */}
        <div className="row g-4">

          {/* LEFT BIG IMAGE CARD */}
          <div className="col-lg-6">
            <div className="gc-card image-card">
              <img  src={`${process.env.PUBLIC_URL}/assets/img/DGCA-Ground-School.jpg`}  alt="DGCA Ground School" />
              <div className="gc-body">
                <h5>DGCA Ground School</h5>
                <p>
                  Structured classroom training focused on strong fundamentals and DGCA exam success.
                </p>
                <Link to="https://rightsourceaviation.com/dgca-classes/" className="gc-btn">
                  Explore More
                </Link>
              </div>
            </div>
          </div>

          {/* RIGHT 2x2 MINI GRID */}
          <div className="col-lg-6">
            <div className="right-grid">

              <div className="gc-mini-card">
                <i className="fas fa-book-open"></i>
                <h5>Private Tutoring (Limited Batch Size)</h5>
                <p>Personalized private tutoring with small batches for focused learning.</p>
              </div>

              <div className="gc-mini-card">
                <i className="fas fa-laptop"></i>
                <h5>DGCA Exam Crash Courses</h5>
                <p>High-intensity revision programs to maximize results in a short time.</p>
              </div>
              
              <div className="gc-mini-card">
  <img
    src={`${process.env.PUBLIC_URL}/assets/img/RSA-Student-28.jpg`}
    alt="DGCA Mock Exams"
    className="mini-img"
  />
</div>

 

              {/* empty slot to keep grid shape like design */}
              <div className="gc-mini-card">
                <i className="fas fa-clipboard-check"></i>
                <h5>DGCA Mock Exams</h5>
                <p>Technology-driven testing with expert supervision and performance tracking.</p>
              </div>

            </div>
          </div>

        </div>

    

        {/* ===== ROW 3 ===== */}
        <div className="row g-4 mt-1">

          <div className="col-lg-4">
            <div className="gc-card icon-card">
              <i className="fas fa-file-alt"></i>
              <h5>ALL Course Materials Provided</h5>
              <p>
                Complete study material, notes, and resources included in training.
              </p>
            </div>
          </div>

          <div className="col-lg-4">
            <div className="gc-card icon-card">
              <i className="fas fa-clock"></i>
              <h5>Batch Timings (Morning / Afternoon / Evening / On-Demand)</h5>
              <p>
                Flexible batch timings to suit students and working professionals.
              </p>
            </div>
          </div>

          <div className="col-lg-4">
            <div className="gc-card icon-card">
              <i className="fas fa-map-marker-alt"></i>
              <h5>Training Locations (BOM, BLR, AMD)</h5>
              <p>
                Classroom training available in Mumbai, Bangalore, and Ahmedabad.
              </p>
            </div>
          </div>

        </div>

      </div>
    </section>
  );
};

export default GroundClasses;
